import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const RoyaltyErrorModal = (props) => {

  return (
    <Modal
      centered
      isOpen={props.isOpen}
      toggle={props.hideError}
      backdrop
    >
      <ModalHeader toggle={props.hideError}>Could not save {props.type}:</ModalHeader>
      <ModalBody>
        <p>
          <strong>Error saving royalty {props.type}.</strong>
        </p>
        <p>
          <em>Note that duplicate names are not allowed.</em>
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={props.hideError}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RoyaltyErrorModal;
